import { createSvgIcon } from '@mui/material';

const GroupByIcon = (props) => {
  const IconCmp = createSvgIcon(
    <>
      <path
        d="M1.5 10.8752L8.73167 14.491C8.83006 14.5402 8.87925 14.5648 8.93085 14.5745C8.97655 14.5831 9.02345 14.5831 9.06915 14.5745C9.12075 14.5648 9.16994 14.5402 9.26833 14.491L16.5 10.8752M1.5 7.12517L8.73167 3.50933C8.83006 3.46014 8.87925 3.43554 8.93085 3.42586C8.97655 3.41729 9.02345 3.41729 9.06915 3.42586C9.12075 3.43554 9.16994 3.46014 9.26833 3.50933L16.5 7.12517L9.26833 10.741C9.16994 10.7902 9.12075 10.8148 9.06915 10.8245C9.02345 10.8331 8.97655 10.8331 8.93085 10.8245C8.87925 10.8148 8.83006 10.7902 8.73167 10.741L1.5 7.12517Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </>,
    'GroupByIcon',
  );
  return <IconCmp style={{ fill: 'none' }} viewBox={'0 0 18 18'} {...props} />;
};
export default GroupByIcon;
